import { Component, OnInit, OnDestroy, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import 'datatables.net';
import { Contato } from '../../../../interfaces/lista-contato/lista-contato.interface';
import { ContatosService } from '../../../../services/contatos.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { StringUtil } from '../../../../infra/string-util';
import { NgZone } from '@angular/core';
import { EnumPermissao } from '../../../../enums/permissoes.enum';
import { PermissaoService } from '../../../../services/permissao.service';
import { ListasService } from '../../../../services/listas.service';
import { EnumTipoDownload } from '../../../../enums/tipo-arquivo-download.enum';
@Component({
  selector: 'app-contatos',
  templateUrl: './contatos.component.html',
  styleUrl: './contatos.component.css',
  standalone: false
})
export class ContatosComponent implements OnInit, OnDestroy {
  constructor(
    private contatosService: ContatosService,
    private router: Router,
    private toastr: ToastrService,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    public permissaoService: PermissaoService,
    private listasService: ListasService,
    private cdr: ChangeDetectorRef
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      const state = navigation.extras.state as any;
      this.idLista = state.idLista;
      this.nomeLista = state.nomeLista;
    } else {
      const savedData = localStorage.getItem('listaContatos');
      if (savedData) {
        const data = JSON.parse(savedData);
        this.idLista = data.idLista;
        this.nomeLista = data.nomeLista;
      }
    }
  }

  EnumPermissao = EnumPermissao;
  EnumTipoDownload = EnumTipoDownload;
  nomeLista: string = '';
  idLista: number = 0;
  contatos: Contato[] = [];
  showDetails = false;
  idContatoDetalhes: string = '';
  carregando: boolean = false;
  exportandoLista: boolean = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  openDetails(idContato: string) {
    this.idContatoDetalhes = idContato;
    this.showDetails = true;
    const mainContent = document.querySelector('app-contatos .main-content');
    const sidebarDetails = document.querySelector('.sidebar-details');

    mainContent?.classList.add('show-details');
    sidebarDetails?.classList.add('show');
  }

  closeDetails() {
    this.showDetails = false;
    this.idContatoDetalhes = '';

    const mainContent = document.querySelector('app-contatos .main-content');
    const sidebarDetails = document.querySelector('.sidebar-details');

    mainContent?.classList.remove('show-details');
    sidebarDetails?.classList.remove('show');
  }

  async ngOnInit(): Promise<void> {
    if (!this.idLista) {
      this.router.navigate(['/area-logada/listas']);
      return;
    }

    try {
      const temPermissaoVisualizarContatos = this.permissaoService.hasPermission(EnumPermissao.VisualizarContatos);
      this.dtOptions = {
        dom: '<"row row-datatables"<"col-sm-12"tr>><"row row-datatables"<"col-sm-12 col-paging d-flex justify-content-center"p>>',
        order: [],
        serverSide: true,
        searching: false,
        lengthChange: false,
        responsive: true,
        info: false,
        pageLength: 10,
        pagingType: 'simple_numbers',
        language: {
          processing: "Processando...",
          zeroRecords: "Nenhum contato encontrado",
          emptyTable: "Nenhum contato disponível",
          paginate: {
            previous: "Anterior",
            next: "Próximo"
          }
        },
        rowCallback: (row: Node, data: Contato, index: number) => {
          const self = this;
          const cursor = this.permissaoService.hasPermission(EnumPermissao.VisualizarContatos) ? 'pointer' : 'not-allowed';
          const title = this.permissaoService.hasPermission(EnumPermissao.VisualizarContatos)
            ? 'Clique para visualizar os detalhes do contato'
            : 'Você não tem permissão para visualizar os detalhes dos contatos';

          $(row).css('cursor', cursor)
            .attr('title', title);
          $('td', row).off('click');
          $('td', row).on('click', () => {
            if (!this.permissaoService.hasPermission(EnumPermissao.VisualizarContatos)) {
              return;
            }

            data.visualizado = true;
            $(row).find('.material-symbols-outlined').addClass('filled');
            this.ngZone.run(() => {
              self.openDetails(data.idContato);
              this.changeDetectorRef.detectChanges();
            });
          });
          return row;
        },
        columns: [
          {
            data: 'nome',
            title: 'Nome',
            orderable: false,
            width: '40%',
            defaultContent: '',
            render: function (data: any, type: any, row: any) {
              return `<p class="text-brand-gray-400 font-medium flex items-center">
                        <span class="material-symbols-outlined text-brand-purple-300 mr-7 ${row.visualizado ? 'filled' : ''}">
                          person
                        </span>
                        ${data ?? ''}
                        </p>`;
            }
          },
          {
            data: 'sexo',
            title: 'Sexo',
            orderable: false,
            width: '10%',
            defaultContent: '',
            render: function (data: any) {
              return StringUtil.obterSexoPorExtenso(data) ?? '';
            }
          },
          {
            data: 'idade',
            title: 'Idade',
            orderable: false,
            width: '10%',
            type: 'text',
            defaultContent: ''
          },
          { data: 'abrangencia', title: 'Abrangência', orderable: false, width: '10%', defaultContent: '' },
          {
            data: null,
            title: '',
            orderable: false,
            className: '',
            width: '30%',
            render: function (data: any, type: any, row: any) {
              let html = '<div class="flex gap-10 justify-end">';
              html += row.convertido ? `<span class="badge rounded-pill text-bg-success visible opacity-100">
                <span class="material-symbols-outlined">check</span>
               </span>` :
                `<span class="badge rounded-pill invisible opacity-0"></span>`;
              
              // Definido em 09/04/2025, a consultar de margem não será implementada neste momento
              /*if (row.temMargem !== undefined) {
                html += `<span class="badge rounded-pill ${row.temMargem ? 'text-bg-info' : 'text-bg-warning'} visible opacity-100">
                <span class="material-symbols-outlined">percent</span>
               </span>`;
              }*/
              html += '</div>';

              return html;
            }
          }
        ],
        ajax: (dataTablesParameters: any, callback: any) => {
          this.carregando = true;
          this.cdr.detectChanges();
          const pagina = (dataTablesParameters.start / dataTablesParameters.length) + 1;
          this.contatosService
            .obterContatosLista(this.idLista, pagina, dataTablesParameters.length)
            .then(response => {
              this.contatos = response.contatos;
              this.carregando = false;
              this.cdr.detectChanges();
              callback({
                recordsTotal: response.totalContatos,
                recordsFiltered: response.totalContatos,
                data: response.contatos
              });                            
            })
            .catch(error => {
              console.error('Erro ao carregar contatos:', error);
              this.carregando = false;
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              this.cdr.detectChanges();
            });
        }
      };
    } catch (error) {
      console.error('Erro ao carregar contatos:', error);
      this.carregando = false;
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    localStorage.removeItem('listaContatos');
    this.dtTrigger.unsubscribe();
  }

  recarregarTabela(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: any) => {
        dtInstance.ajax.reload();
      });
    }
  }

  voltarParaListas(event: Event): void {
    event.preventDefault();
    const paginaAnterior = localStorage.getItem('listaSalvaPagina') || '1';

    this.router.navigate(['/area-logada/listas'], {
      state: { paginaAtual: parseInt(paginaAnterior) }
    });
  }

  onContatoConvertido(idContato: string): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      const rowData = dtInstance.rows().data().toArray();
      const rowIndex = rowData.findIndex((row: any) => row.idContato === idContato);

      if (rowIndex !== -1) {
        rowData[rowIndex].convertido = true;
        dtInstance.row(rowIndex).data(rowData[rowIndex]).draw(false);
      }
    });
  }

  onContatoRemoverVenda(idContato: string): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      const rowData = dtInstance.rows().data().toArray();
      const rowIndex = rowData.findIndex((row: any) => row.idContato === idContato);

      if (rowIndex !== -1) {
        rowData[rowIndex].convertido = false;
        dtInstance.row(rowIndex).data(rowData[rowIndex]).draw(false);
      }
    });
  }

  async exportarLista(tipoDownload: EnumTipoDownload): Promise<void> {
    const dropdownMenu = document.querySelector('.dropdown-menu');
    dropdownMenu?.classList.remove('show');

    if (!this.permissaoService.hasPermission(EnumPermissao.ExportarLista)) {
      this.toastr.warning("Você não tem permissão para exportar a lista", "Atenção");
      return;
    }

    if (this.exportandoLista) {
      this.toastr.warning("Uma exportação já está em andamento, aguarde a conclusão", "Atenção");
      return;
    }

    try {
      this.exportandoLista = true;
      const blob = await this.listasService.downloadListaContato(this.idLista, tipoDownload);
      const url = window.URL.createObjectURL(blob.blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = blob.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      this.toastr.error('Erro ao baixar arquivo');
    } finally {
      this.exportandoLista = false;
    }
  }
}
